<app-simple-block-result
  [question]="question"
  [options]="options"
>
</app-simple-block-result>
